import { BsArrowRight } from "react-icons/bs";

const OdooSOPreview = ({
  orderId,
  orderNumber,
  customerName,
  invoiceAddress,
  deliveryAddress,
  warehouseName,
  incoterms,
  pricelistName,
  paymentTerm,
  orderTotal,
  orderLines,
  hidePrice,
  compareOdoo,
}) => {
  return (
    <div>
      {orderId && orderNumber && (
        <h5 className="mb-2">
          {orderId} - {orderNumber}
        </h5>
      )}

      <div className="-mx-2">
        <table className="td-align-baseline">
          <tbody>
            <tr>
              <td>
                <label>Customer:</label>
              </td>
              <td className="w-full">{customerName}</td>
            </tr>
            <tr>
              <td>
                <label>Invoice Address:</label>
              </td>
              <td className="w-full">{invoiceAddress}</td>
            </tr>
            <tr>
              <td>
                <label>Delivery Address:</label>
              </td>
              <td className="w-full">{deliveryAddress}</td>
            </tr>
            <tr>
              <td>
                <label>Warehouse:</label>
              </td>
              <td className="w-full">{warehouseName}</td>
            </tr>
            {incoterms && (
              <tr>
                <td>
                  <label>Incoterms:</label>
                </td>
                <td className="w-full">{incoterms}</td>
              </tr>
            )}
            {pricelistName && (
              <tr>
                <td>
                  <label>Pricelist:</label>
                </td>
                <td className="w-full">{pricelistName}</td>
              </tr>
            )}
            {paymentTerm && (
              <tr>
                <td>
                  <label>Payment Term:</label>
                </td>
                <td className="w-full">{paymentTerm}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="-mx-2 mt-4">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              {!hidePrice && <th className="text-right">Unit Price</th>}
              <th className="text-right">Quantity</th>
              {!hidePrice && <th className="text-right">Total</th>}
            </tr>
          </thead>
          <tbody>
            {orderLines.map((line) => (
              <tr
                key={line.id}
                className={`border-y border-gray-100 dark:border-gray-700
                  ${
                    compareOdoo && line.odooQty !== line.qty
                      ? "text-red-600"
                      : ""
                  }
                  `}
              >
                <td>{line.name}</td>
                {!hidePrice && (
                  <td className="text-right">{line.unitPrice.toFixed(2)}</td>
                )}
                <td className="text-right">
                  {compareOdoo ? (
                    <div className="flex justify-end items-center space-x-2 whitespace-nowrap">
                      <span>{line.odooQty}</span>
                      <BsArrowRight />
                      <span>{line.qty}</span>
                    </div>
                  ) : (
                    line.qty
                  )}
                </td>
                {!hidePrice && (
                  <td className="text-right">{line.total.toFixed(2)}</td>
                )}
              </tr>
            ))}
          </tbody>
          {orderTotal && (
            <tfoot>
              <tr className="font-semibold">
                <td>Total</td>
                <td></td>
                <td></td>
                <td className="text-right">{orderTotal.toFixed(2)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>

      <div className="mt-8 opacity-70">
        <p className="font-semibold">Note ⚠️</p>
        <p>Same products will be merged into one line.</p>
        <p>
          Commissions will be auto set to the Customer Sale Representative Info
          with 100% by default.
        </p>
        <p>
          Sales Price will be auto set to the customer's pricelist from odoo.
        </p>
        <p>You can change the order info in Odoo after syncing.</p>
      </div>
    </div>
  );
};

export default OdooSOPreview;
